import i18n from "@/i18n";
import {
  searchEmailConfig,
  getEmailConfig,
  createEmailConfig,
  updateEmailConfig,
  deleteEmailConfig,
} from "@/store/services/configuration/emailConfigService";
import { EmailConfigState } from "@/types";
import Notify from 'quasar/src/plugins/Notify.js';;
import { Module } from "vuex";

const emailConfigModule: Module<EmailConfigState, unknown> = {
  namespaced: true,
  state: {
    emailConfigList: [],
    selectedEmailConfig: {},
    isLoading: false,
  },
  getters: {
    getEmailConfigList: (state): any[] => {
      return state.emailConfigList;
    },
    getSelectedEmailConfig: (state): any => {
      return state.selectedEmailConfig;
    },
    getIsLoading: (state): boolean => {
      return state.isLoading;
    },
  },
  actions: {
    searchEmailConfig({ commit }, payload) {
      const { filter, offset, limit, callback } = payload;
      searchEmailConfig(filter, offset, limit)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    getEmailConfig({ commit }, payload) {
      const { resourceUid, callback } = payload;
      getEmailConfig(resourceUid)
        .then((res: any) => {
          commit("setSelectedEmailConfig", res.data);
          if (callback) callback(res.data);
        })
        .catch((e: any) => {
          console.error(e);
          Notify.create({
            message: i18n.global.t("main.dialog.loadError", { entity: resourceUid }),
            color: "negative",
          });
        });
    },
    createEmailConfig({ commit }, payload) {
      const { emailConfig, callback } = payload;
      createEmailConfig(emailConfig)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("main.dialog.success", { entity: res.data?.resourceUid }),
            color: "positive",
          });
          if (callback) callback(res);
        })
        .catch((e: any) => console.error(e));
    },
    updateEmailConfig({ commit }, payload) {
      const { resourceUid, emailConfig, callback, options } = payload;
      updateEmailConfig(resourceUid, emailConfig, options)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("main.dialog.success", { entity: res.data?.resourceUid }),
            color: "positive",
          });
          if (callback) callback(res);
        })
        .catch((e: any) => console.error(e));
    },
    deleteEmailConfig({ commit }, payload) {
      const { resourceUid, callback } = payload;
      deleteEmailConfig(resourceUid)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("order.messages.deleteSuccess"),
            color: "positive",
          });
          if (callback) callback(res);
        })
        .catch((err: any) => {
          console.error(err);
          Notify.create({
            message: err,
            color: "negative",
          });
        });
    },
    cleanState({ commit }) {
      commit("setInitial");
    },
  },
  mutations: {
    setEmailConfigList(state, payload) {
      state.emailConfigList = payload;
    },
    setSelectedEmailConfig(state, payload) {
      state.selectedEmailConfig = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setInitial(state) {
      state.emailConfigList = [];
      state.selectedEmailConfig = {};
      state.isLoading = false;
    },
  },
};

export default emailConfigModule;
